import { render, staticRenderFns } from "./TextInfoItem.vue?vue&type=template&id=74c2f1e2&"
import script from "./TextInfoItem.vue?vue&type=script&lang=js&"
export * from "./TextInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports